import {
  ICustomCode,
  ICustomCodeCollection,
  ICustomCodeProps,
} from "./customCode.types";

export class CustomCodeCollection implements ICustomCodeCollection {
  codeGroupName: string;
  codeGroup: string;
  customCodes: ICustomCode[];

  constructor(data: ICustomCodeCollection) {
    this.codeGroupName = data.codeGroupName;
    this.codeGroup = data.codeGroup;
    this.customCodes = data.customCodes;
  }
}

export class CustomCode implements ICustomCode {
  uid: string;
  codeGroup: string;
  code: string;
  name: string;
  displayOrder: number;
  priorityOrder: number;
  props?: ICustomCodeProps;

  constructor(data: ICustomCode) {
    this.uid = data.uid;
    this.codeGroup = data.codeGroup;
    this.code = data.code;
    this.name = data.name;
    this.displayOrder = data.displayOrder;
    this.priorityOrder = data.priorityOrder;
    this.props = data.props;
  }
}
